import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api";

export const fetchContactInfo = createAsyncThunk(
  "contact/fetchContactInfo",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("contact/contact-info/");
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load contact info");
    }
  }
);

export const sendContactMessage = createAsyncThunk(
  "contact/sendContactMessage",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await api.post("contact/contact-message/", formData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to send message");
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    info: null,
    loadingInfo: false,
    errorInfo: null,
    sending: false,
    successMessage: null,
    errorMessage: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactInfo.pending, (state) => {
        state.loadingInfo = true;
        state.errorInfo = null;
      })
      .addCase(fetchContactInfo.fulfilled, (state, action) => {
        state.loadingInfo = false;
        state.info = action.payload;
      })
      .addCase(fetchContactInfo.rejected, (state, action) => {
        state.loadingInfo = false;
        state.errorInfo = action.payload;
      })
      .addCase(sendContactMessage.pending, (state) => {
        state.sending = true;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(sendContactMessage.fulfilled, (state) => {
        state.sending = false;
        state.successMessage = "Message sent successfully!";
      })
      .addCase(sendContactMessage.rejected, (state, action) => {
        state.sending = false;
        state.errorMessage = action.payload;
      });
  },
});

export const { clearMessages } = contactSlice.actions;
export default contactSlice.reducer;
